import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

export type PracticePathCheckerResultDialogCheck = {
  criticalPointUuid: string;
  criticalPointTitle: string;
  isOk: boolean;
  reason?: string;
};

export type PracticePathCheckerResultDialogData = {
  workflowId: string;
  practicePathUuid: string;
  checks: PracticePathCheckerResultDialogCheck[];
};

@Component({
  selector: "app-practice-path-checker-result-dialog",
  templateUrl: "./practice-path-checker-result-dialog.component.html",
  styleUrls: ["./practice-path-checker-result-dialog.component.scss"],
})
export class PracticePathCheckerResultDialogComponent {
  protected readonly failedChecks: PracticePathCheckerResultDialogCheck[];
  protected readonly successfulChecksCount: number;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    protected readonly data: PracticePathCheckerResultDialogData
  ) {
    this.failedChecks = data.checks.filter((check) => check.isOk === false);
    this.successfulChecksCount = data.checks.length - this.failedChecks.length;
  }

  public static open(
    dialogService: MatDialog,
    data: PracticePathCheckerResultDialogData
  ): MatDialogRef<PracticePathCheckerResultDialogComponent, void> {
    return dialogService.open<
      PracticePathCheckerResultDialogComponent,
      PracticePathCheckerResultDialogData,
      void
    >(PracticePathCheckerResultDialogComponent, {
      data,
      minWidth: "560px",
      maxWidth: "920px",
      width: "70vw",
    });
  }
}
